import { render, staticRenderFns } from "./TicketOverviewData.vue?vue&type=template&id=6dee0816&scoped=true"
import script from "./TicketOverviewData.vue?vue&type=script&lang=ts"
export * from "./TicketOverviewData.vue?vue&type=script&lang=ts"
import style0 from "./TicketOverviewData.vue?vue&type=style&index=0&id=6dee0816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dee0816",
  null
  
)

export default component.exports